import React, { useState } from "react";
import { Modal } from "../intel/IntelKit";
import { api } from "../../lib/api";

const CATEGORIES = ["Growth", "Finance", "Strategy", "Sales", "Marketing",
  "Operations", "Technology", "People", "Other"];

export default function ExpertRequestModal({ open, onClose, onCreated }) {
  const [category, setCategory] = useState("Growth");
  const [requestText, setRequestText] = useState("");
  const [desiredOutcome, setDesiredOutcome] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const reset = () => { setCategory("Growth"); setRequestText(""); setDesiredOutcome(""); setError(""); };
  const close = () => { reset(); onClose(); };

  const submit = async () => {
    if (!requestText.trim() || submitting) return;
    setSubmitting(true); setError("");
    const res = await api.expertCreateRequest({ category, requestText: requestText.trim(), desiredOutcome });
    setSubmitting(false);
    if (!res.ok) { setError(res.error || "Could not submit your request. Please try again."); return; }
    onCreated(res.data?.request);
    reset();
  };

  return (
    <Modal open={open} onClose={close} title="Talk to C-ORE Expert" testid="expert-request-modal">
      <div className="space-y-4">
        <div>
          <label className="text-[12px] font-semibold text-slate-600">What would you like help with?</label>
          <textarea
            data-testid="expert-request-text"
            value={requestText}
            onChange={(e) => setRequestText(e.target.value)}
            rows={4}
            maxLength={4000}
            placeholder="Tell us what you're currently trying to solve, decide, improve, or understand."
            className="mt-1.5 w-full rounded-lg border border-slate-200 px-3 py-2.5 text-[13.5px] focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]/20"
          />
        </div>
        <div>
          <label className="text-[12px] font-semibold text-slate-600">Area</label>
          <select
            data-testid="expert-request-category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="mt-1.5 w-full rounded-lg border border-slate-200 px-3 py-2.5 text-[13.5px] bg-white focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]/20"
          >
            {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div>
          <label className="text-[12px] font-semibold text-slate-600">What outcome are you looking for? <span className="text-slate-400 font-normal">(optional)</span></label>
          <textarea
            data-testid="expert-request-outcome"
            value={desiredOutcome}
            onChange={(e) => setDesiredOutcome(e.target.value)}
            rows={2}
            maxLength={2000}
            placeholder="What would you like to be clearer about after speaking with C-ORE Expert?"
            className="mt-1.5 w-full rounded-lg border border-slate-200 px-3 py-2.5 text-[13.5px] focus:outline-none focus:ring-2 focus:ring-[#1E3A5F]/20"
          />
        </div>
        {error && <div data-testid="expert-request-error" className="text-[12.5px] text-red-600">{error}</div>}
        <button
          data-testid="expert-request-submit"
          onClick={submit}
          disabled={!requestText.trim() || submitting}
          className="w-full rounded-lg bg-[#1E3A5F] text-white py-2.5 text-[13.5px] font-semibold disabled:opacity-50 hover:opacity-90 transition"
        >
          {submitting ? "Submitting…" : "Raise Expert Request"}
        </button>
      </div>
    </Modal>
  );
}
